// Masifi: las páginas del Panel de Control en UNA tabla (P8): las rutas (controlPanel.routes.js) y el menú
// (useMasifiSidebar) salen de acá. `key` = la de Masifi::Console::Scope::PAGES: quién ve cada página lo decide el
// backend (/me → `pages`). El orden de la tabla es el del menú. `menu(access)` (opcional) saca una página del menú sin
// cerrarle la ruta. Agregar una página = 1 fila.
export const CONTROL_PANEL_PAGES = Object.freeze([
  {
    key: 'summary',
    name: 'control_panel_summary',
    path: 'summary',
    navName: 'Control Panel Summary',
    navLabel: 'CONTROL_PANEL.NAV.SUMMARY',
    component: () => import('../pages/ControlPanelSummary.vue'),
  },
  {
    key: 'accounts',
    name: 'control_panel_accounts',
    path: 'accounts',
    navName: 'Control Panel Accounts',
    navLabel: 'CONTROL_PANEL.NAV.ACCOUNTS',
    component: () => import('../pages/ControlPanelAccounts.vue'),
  },
  {
    key: 'resellers',
    name: 'control_panel_resellers',
    path: 'resellers',
    navName: 'Control Panel Resellers',
    navLabel: 'CONTROL_PANEL.NAV.RESELLERS',
    component: () => import('../pages/ControlPanelResellers.vue'),
  },
  {
    key: 'brand',
    name: 'control_panel_brand',
    path: 'brand',
    navName: 'Control Panel Brand',
    navLabel: 'CONTROL_PANEL.NAV.BRAND',
    component: () => import('../pages/ControlPanelBrand.vue'),
  },
  {
    key: 'domains',
    name: 'control_panel_domains',
    path: 'domains',
    navName: 'Control Panel Domains',
    navLabel: 'CONTROL_PANEL.NAV.DOMAINS',
    component: () => import('../pages/ControlPanelDomains.vue'),
  },
  {
    key: 'cloudflare',
    name: 'control_panel_cloudflare',
    path: 'cloudflare',
    navName: 'Control Panel Cloudflare',
    navLabel: 'CONTROL_PANEL.NAV.CLOUDFLARE',
    component: () => import('../pages/ControlPanelCloudflare.vue'),
  },
  {
    key: 'team',
    name: 'control_panel_team',
    path: 'team',
    navName: 'Control Panel Team',
    navLabel: 'CONTROL_PANEL.NAV.TEAM',
    // La raíz tiene la página (abre el equipo de una agencia desde Agencias), pero no en el menú: no tiene equipo propio.
    menu: access => access.scope === 'reseller',
    component: () => import('../pages/ControlPanelTeam.vue'),
  },
  {
    key: 'activity',
    name: 'control_panel_activity',
    path: 'activity',
    navName: 'Control Panel Activity',
    navLabel: 'CONTROL_PANEL.NAV.ACTIVITY',
    component: () => import('../pages/ControlPanelActivity.vue'),
  },
]);

export const menuPages = access =>
  access?.scope
    ? CONTROL_PANEL_PAGES.filter(
        page =>
          access.pages?.includes(page.key) && (!page.menu || page.menu(access))
      )
    : [];
